module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/xml-f3de2bd9c367adbb7ea3eda78133b391.svg";